<template>
  <el-dialog width="60%"
             title="活动发起"
             :visible.sync="viewDetail"
             @close="closeModel">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             style="margin-bottom:20px">
      <el-form-item label="活动名称:"
                    prop='name'
                    :label-width="formLabelWidth">
        <el-input v-model="ruleForm.name"
                  placeholder="请输入活动名称"
                  clearable
                  autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="关联店铺:"
                    prop='shopname'
                    :label-width="formLabelWidth">
        <el-select v-model="ruleForm.shopname"
                   autocomplete="off"
                   clearable
                   filterable
                   remote
                   :remote-method="remoteMethod"
                   placeholder="请输入关联店铺"
                   @change="shopname_select">
          <el-option v-for="item in mailOptions"
                     :key="item.id"
                     :label="item.shop_name"
                     :value="item.shop_name">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="返佣设定:"
                    prop='name'
                    :label-width="formLabelWidth">
        <el-input v-model="ruleForm.money"
                  placeholder="请输入返佣设定"
                  clearable
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="开始时间:"
                    :label-width="formLabelWidth">
        <el-date-picker v-model="ruleForm.starttime"
                        type="date"
                         :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd"
                        placeholder="请输入开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间:"
                    :label-width="formLabelWidth">
        <el-date-picker v-model="ruleForm.endtime"
                        type="date"
                           :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd"
                        placeholder="请输入结束时间">
        </el-date-picker>
      </el-form-item>
      <!--   -->
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="closeModel">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getshoplist, setshoplist, editrebateshop } from '@/api/erweima/index'
export default {
  props: {
    method: {
      type: Function
    },
    rowlist: {
      type: Object
    }
  },
  data () {
    return {
      viewDetail: true,
      loading: false,
       pickerOptions1: {
          disabledDate(time) {
            return time.getTime()-86400000 < (Date.now() - 24*60*60*1000);
          //  return time.getTime() < Date.now() - 8.64e7;
          },
        },
      ruleForm: {
        name: '',
        shopname: '',
        money: '',
        starttime: '',
        endtime: ''
      },
      rules: {
        name: [
          { required: true, trigger: 'blur', message: '请填写名称' }
        ],
        shopname: [
          { required: true, trigger: 'blur', message: '请填写名称' }
        ],
        money: [
          { required: true, trigger: 'blur', message: '请填写名称' }
        ]
      },
      formLabelWidth: '120px',
      remoteLoading: false,
      mailOptions: [],
      mailOptionsCopy: [],
      mail_id: ''


    };
  },
  mounted () {

    if (this.rowlist) {
      this.ruleForm.name = this.rowlist.name
      this.ruleForm.money = this.rowlist.proportion
      this.ruleForm.starttime = this.rowlist.begin_time
      this.ruleForm.endtime = this.rowlist.end_time
    }

  },
  methods: {
    closeModel () {
      this.$emit("closeModel");
    },
    handleSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.setshoplist_()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    shopname_select (val) {
      let obj = {}
      obj = this.mailOptions.find((item) => {
        return item.shop_name == val;

      });
      this.mail_id = obj.id
    },
    remoteMethod (query) {
      if (query !== '') {
        this.remoteLoading = true
        setTimeout(() => {
          this.mailOptions = this.mailOptionsCopy.filter(item => {
            return item.shop_name
              .indexOf(query) > -1
          })
        }, 200)
      } else {
        this.mailOptions = []
      }
    },
    getshoplist_ () {
      let par = {
        token: this.$getSessionStorage('token'),
      }
      getshoplist(par).then(res => {
        if (res.code == 1) {
          this.mailOptionsCopy = res.data.list
        } else {
          this.$message.error({ message: res.msg })
        }
      }).catch(err => {

      })
    },
    setshoplist_ () {

      let par = {
        token: this.$getSessionStorage('token'),
        name: this.ruleForm.name,
        proportion: this.ruleForm.money,
        opt_id: this.$getSessionStorage('userid'),//运营人
        begin_time: this.ruleForm.starttime,
        end_time: this.ruleForm.endtime,
      }

      setshoplist(par).then(res => {
        if (res.code == 1) {
          this.$message.success({ message: '创建成功' })
          this.method()
          this.closeModel()
        } else {
          this.$message.error({ message: res.msg })
        }
      }).catch(err => {
      })
    }

  },
  components: {

  },
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
::v-deep .el-select {
  width: 100%;
}
</style>
